import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Components
import EventsTimelineCellDropTarget from './components/EventsTimelineCellDropTarget';
import EventsTimelineEvent from './components/EventsTimelineEvent';

// Selectors
import { makeSelectEventUuids } from './selectors';

// Styles
import './styles.scss';

interface Props {
    groupId?: ?number;
    eventUuids?: string[];
    date: string;
}

export class EventsTimelineCell extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props) {
        const { props } = this;
        return !isEqual(props.eventUuids, nextProps.eventUuids);
    }

    render() {
        const { groupId, date, eventUuids } = this.props;
        return (
            <EventsTimelineCellDropTarget groupId={groupId} date={date}>
                {eventUuids &&
                    eventUuids.map((eventUuid, index) => {
                        // Assume placeholder is unnecessary if previous slot was empty
                        if (index && !eventUuids[index - 1]) {
                            return null;
                        }
                        return (
                            <EventsTimelineEvent
                                key={eventUuid}
                                groupId={groupId}
                                harvestEventUuid={eventUuid}
                            />
                        );
                    })}
            </EventsTimelineCellDropTarget>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    eventUuids: makeSelectEventUuids()
});

export default connect(mapStateToProps)(EventsTimelineCell);
